var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.2775,
    cy: 22.8491,
    rx: 22.0022,
    ry: 22.1254,
    fill: "#FFB27E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2797 22.8491C44.2797 26.5214 43.3708 30.1359 41.6348 33.3667C39.8989 36.5975 37.3906 39.3431 34.336 41.3557L22.2775 22.8491H44.2797Z",
    fill: "#D47434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2797 22.8491C44.2797 19.7042 43.613 16.5954 42.324 13.7301C41.0351 10.8647 39.1535 8.30859 36.8047 6.23213C34.4559 4.15568 31.694 2.6066 28.7029 1.68818C25.7119 0.769768 22.5605 0.503117 19.4589 0.906008C16.3573 1.3089 13.3767 2.37208 10.7159 4.02465C8.0551 5.67723 5.77521 7.88123 4.02823 10.4897C2.28126 13.0982 1.10734 16.0512 0.584751 19.1519C0.0621587 22.2526 0.2029 25.4297 0.997591 28.4714L19.4589 36.3573L44.2797 22.8491Z",
    fill: "#FF8B3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAvatar);
export default __webpack_public_path__ + "static/media/bg-avatar.89420774972cb3f0b7c73753fcd4c7c3.svg";
export { ForwardRef as ReactComponent };